module.exports = __webpack_public_path__ + "img/education1jpg.30d77ddd.jpg";